document.addEventListener('DOMContentLoaded', function () {
    var sidebarToggle = document.getElementById('sidebarToggle');
    var mobileMenuToggle = document.querySelector('[data-sidebar-menu-toggle]');
    var mobileMenu = document.getElementById('sidebarMenu');
    var sidebarStateKey = 'sidebarCollapsed';
    var sidebarCollapsedClass = 'sidebar-collapsed';
    var mobileMenuOpenClass = 'sidebar-menu-open';
    var mobileLayoutQuery = window.matchMedia('(max-width: 991.98px)');
    var setSidebarState = function (isCollapsed) {
        document.body.classList.toggle(sidebarCollapsedClass, isCollapsed);
        sidebarToggle === null || sidebarToggle === void 0 ? void 0 : sidebarToggle.setAttribute('aria-expanded', String(!isCollapsed));
    };
    var readSidebarState = function () {
        try {
            return window.localStorage.getItem(sidebarStateKey);
        }
        catch (_a) {
            return null;
        }
    };
    var saveSidebarState = function (isCollapsed) {
        try {
            window.localStorage.setItem(sidebarStateKey, String(isCollapsed));
        }
        catch (_a) {
            // Ignore storage failures; the toggle should still work for the current page.
        }
    };
    if (sidebarToggle) {
        var savedState = readSidebarState();
        var initialCollapsed = savedState === null
            ? mobileLayoutQuery.matches
            : savedState === 'true';
        setSidebarState(initialCollapsed);
        sidebarToggle.addEventListener('click', function () {
            var isCollapsed = !document.body.classList.contains(sidebarCollapsedClass);
            setSidebarState(isCollapsed);
            saveSidebarState(isCollapsed);
        });
    }
    mobileMenuToggle === null || mobileMenuToggle === void 0 ? void 0 : mobileMenuToggle.addEventListener('click', function () {
        mobileMenu === null || mobileMenu === void 0 ? void 0 : mobileMenu.classList.toggle(mobileMenuOpenClass);
    });
    document.querySelectorAll('[data-current-page="true"]').forEach(function (link) {
        link.addEventListener('click', function (event) {
            event.preventDefault();
        });
    });
    document.querySelectorAll('[data-app-url]').forEach(function (link) {
        link.addEventListener('click', function (event) {
            var appUrl = link.dataset.appUrl;
            var webUrl = link.href;
            var isLikelyMobile = /Android|iPhone|iPad|iPod/i.test(window.navigator.userAgent);
            if (!appUrl || !isLikelyMobile)
                return;
            event.preventDefault();
            var startedAt = Date.now();
            window.location.href = appUrl;
            window.setTimeout(function () {
                if (Date.now() - startedAt < 1600) {
                    window.open(webUrl, '_blank', 'noopener');
                }
            }, 900);
        });
    });
    var initTooltips = function () {
        var triggers = Array.from(document.querySelectorAll('[data-tooltip]'));
        if (triggers.length === 0)
            return;
        var tooltip = document.createElement('div');
        tooltip.className = 'admin-tooltip';
        tooltip.setAttribute('role', 'tooltip');
        document.body.appendChild(tooltip);
        var activeTrigger = null;
        var showTimer = null;
        var clearShowTimer = function () {
            if (showTimer === null)
                return;
            window.clearTimeout(showTimer);
            showTimer = null;
        };
        var positionTooltip = function (trigger) {
            var rect = trigger.getBoundingClientRect();
            var tooltipRect = tooltip.getBoundingClientRect();
            var spacing = 8;
            var top = window.scrollY + rect.bottom + spacing;
            var left = window.scrollX + rect.left + (rect.width / 2) - (tooltipRect.width / 2);
            var maxLeft = window.scrollX + document.documentElement.clientWidth - tooltipRect.width - spacing;
            tooltip.style.top = "".concat(top, "px");
            tooltip.style.left = "".concat(Math.max(window.scrollX + spacing, Math.min(left, maxLeft)), "px");
        };
        var hideTooltip = function () {
            clearShowTimer();
            activeTrigger = null;
            tooltip.classList.remove('show');
            tooltip.textContent = '';
        };
        var showTooltip = function (trigger) {
            var text = trigger.dataset.tooltip;
            if (!text)
                return;
            activeTrigger = trigger;
            tooltip.textContent = text;
            tooltip.classList.add('show');
            positionTooltip(trigger);
        };
        var queueTooltip = function (trigger) {
            clearShowTimer();
            showTimer = window.setTimeout(function () {
                showTooltip(trigger);
            }, 500);
        };
        triggers.forEach(function (trigger) {
            trigger.addEventListener('mouseenter', function () { return queueTooltip(trigger); });
            trigger.addEventListener('mouseleave', hideTooltip);
            trigger.addEventListener('focus', function () { return queueTooltip(trigger); });
            trigger.addEventListener('blur', hideTooltip);
        });
        window.addEventListener('scroll', function () {
            if (activeTrigger)
                positionTooltip(activeTrigger);
        }, { passive: true });
        window.addEventListener('resize', function () {
            if (activeTrigger)
                positionTooltip(activeTrigger);
        });
        document.addEventListener('keydown', function (event) {
            if (event.key === 'Escape') {
                hideTooltip();
            }
        });
    };
    initTooltips();
    var initMessageModal = function () {
        var modal = document.querySelector('[data-message-modal]');
        var content = modal === null || modal === void 0 ? void 0 : modal.querySelector('[data-message-content]');
        var closeButton = modal === null || modal === void 0 ? void 0 : modal.querySelector('[data-message-close]');
        var expandButtons = Array.from(document.querySelectorAll('[data-message-expand]'));
        if (!modal || !content || expandButtons.length === 0)
            return;
        var activeButton = null;
        var closeModal = function () {
            modal.classList.remove('show');
            modal.setAttribute('aria-hidden', 'true');
            document.body.classList.remove('admin-modal-open');
            content.innerHTML = '';
            activeButton === null || activeButton === void 0 ? void 0 : activeButton.focus();
            activeButton = null;
        };
        var openModal = function (button) {
            var templateId = button.dataset.messageTemplate;
            var template = templateId ? document.getElementById(templateId) : null;
            if (!(template instanceof HTMLTemplateElement))
                return;
            activeButton = button;
            content.replaceChildren(template.content.cloneNode(true));
            modal.classList.add('show');
            modal.setAttribute('aria-hidden', 'false');
            document.body.classList.add('admin-modal-open');
            closeButton === null || closeButton === void 0 ? void 0 : closeButton.focus();
        };
        expandButtons.forEach(function (button) {
            button.addEventListener('click', function () { return openModal(button); });
        });
        closeButton === null || closeButton === void 0 ? void 0 : closeButton.addEventListener('click', closeModal);
        modal.addEventListener('click', function (event) {
            if (event.target === modal) {
                closeModal();
            }
        });
        document.addEventListener('keydown', function (event) {
            if (!modal.classList.contains('show') || event.key !== 'Escape')
                return;
            closeModal();
        });
    };
    initMessageModal();
    var modalElement = document.getElementById('imageModal');
    var modalImage = document.getElementById('modalImage');
    var galleryClose = document.getElementById('galleryClose');
    var galleryPrev = document.getElementById('galleryPrev');
    var galleryNext = document.getElementById('galleryNext');
    if (!modalElement || !modalImage)
        return;
    var galleryItems = Array.from(document.querySelectorAll('[data-gallery-item]'));
    var activeGalleryIndex = 0;
    var getGalleryItem = function (target) {
        return target instanceof Element
            ? target.closest('[data-gallery-item]')
            : null;
    };
    var setGalleryImage = function (index) {
        var item = galleryItems[index];
        var image = item === null || item === void 0 ? void 0 : item.querySelector('.portfolio-item');
        var imageSrc = (item === null || item === void 0 ? void 0 : item.dataset.full) || (image === null || image === void 0 ? void 0 : image.dataset.full) || (image === null || image === void 0 ? void 0 : image.src);
        if (!imageSrc)
            return;
        activeGalleryIndex = index;
        modalImage.src = imageSrc;
        modalImage.alt = (image === null || image === void 0 ? void 0 : image.alt) || '';
    };
    var openGallery = function (index) {
        setGalleryImage(index);
        modalElement.classList.add('show');
        modalElement.removeAttribute('aria-hidden');
        modalElement.setAttribute('aria-modal', 'true');
        modalElement.setAttribute('role', 'dialog');
        document.body.classList.add('lightbox-open');
    };
    var closeGallery = function () {
        modalElement.classList.remove('show');
        modalElement.setAttribute('aria-hidden', 'true');
        modalElement.removeAttribute('aria-modal');
        modalElement.removeAttribute('role');
        document.body.classList.remove('lightbox-open');
    };
    var openGalleryItem = function (item) {
        var index = galleryItems.indexOf(item);
        if (index === -1)
            return;
        openGallery(index);
    };
    var moveGallery = function (direction) {
        if (galleryItems.length === 0)
            return;
        var nextIndex = (activeGalleryIndex + direction + galleryItems.length) % galleryItems.length;
        setGalleryImage(nextIndex);
    };
    document.addEventListener('click', function (event) {
        var item = getGalleryItem(event.target);
        if (!item)
            return;
        event.preventDefault();
        openGalleryItem(item);
    });
    document.addEventListener('keydown', function (event) {
        var item = getGalleryItem(event.target);
        if (!item || (event.key !== 'Enter' && event.key !== ' '))
            return;
        event.preventDefault();
        openGalleryItem(item);
    });
    galleryPrev === null || galleryPrev === void 0 ? void 0 : galleryPrev.addEventListener('click', function (event) {
        event.stopPropagation();
        moveGallery(-1);
    });
    galleryNext === null || galleryNext === void 0 ? void 0 : galleryNext.addEventListener('click', function (event) {
        event.stopPropagation();
        moveGallery(1);
    });
    galleryClose === null || galleryClose === void 0 ? void 0 : galleryClose.addEventListener('click', closeGallery);
    modalElement.addEventListener('click', function (event) {
        if (event.target === modalElement) {
            closeGallery();
        }
    });
    document.addEventListener('keydown', function (event) {
        if (!modalElement.classList.contains('show'))
            return;
        if (event.key === 'Escape') {
            closeGallery();
        }
        if (event.key === 'ArrowLeft') {
            moveGallery(-1);
        }
        if (event.key === 'ArrowRight') {
            moveGallery(1);
        }
    });
});
